import successIMG from "../../../images/success.svg";
import rocks from "../../../images/project/rocks.svg";
import stakeHolderIMG from "../../../images/project/stakeholder.svg";
import changeManagementIMG from "../../../images/project/change_management.svg";
import styled from "styled-components";
import EditButton from "../../buttons/EditButton";
import {sliceText} from "../../../utils/utils";

const SuccessDifficultyThreat = ({name, value, canBeUpdated = false, openModal}) => {

    const getImage = () => {
        if (name === "success") {
            return successIMG
        }
        if (name === "difficulties") {
            return rocks
        }

        if (name === "threatCreated") {
            return stakeHolderIMG
        }
        if (name === "threatNotCreated") {
            return changeManagementIMG
        }
    }

    const getTitle = () => {
        if (name === "success") {
            return "Succès"
        }
        if (name === "difficulties") {
            return "Cailloux"
        }

        if (name === "threatCreated") {
            return "Les parties prenantes"
        }
        if (name === "threatNotCreated") {
            return "Conduite du changement nécessaire"
        }
    }

    return (
        <div className={"flex-col gap-05"}>
            <div className={"flex-row jtc-center  ai-center gap-05"}>
                <img src={getImage(name)} alt=""/>
                <h2> {getTitle(name)}</h2>
                {canBeUpdated &&
                <EditButton
                    setUpdate={openModal}
                    data={name}
                />
                }
            </div>
            <ContainerValue>
                <p> {sliceText(value, 245)}</p>
            </ContainerValue>
        </div>
    )
}

const ContainerValue = styled.div`
  background-color: var(--color-grey-03);
  border-radius: 15px;
  padding: 2em;
  min-height: 10em;
  max-height: 10em;
  overflow: hidden;
  width: 1fr;
  white-space: pre-line;
  p{
    font-size: 15px ;
  }
`

export default SuccessDifficultyThreat;